import React, { useRef, useState } from 'react';
import JiraBugReportModal, {
    JiraBugReportFormValues,
    JiraBugReportModalHandle,
} from 'components/molecules/JiraBugReportModal';
import useCreateJiraRequest from 'hooks/general/useCreateJiraRequest';
import { prepareJiraRequestPayload } from 'utils/jiraUtils';
import { BugOutlined } from '@ant-design/icons';
import { sendNotification } from 'utils/helperMethods';
import { Tooltip } from 'antd';
import { colorConstants } from 'config/colorConstants';

const JiraComponent = ({ size = 48 }: { size?: number }) => {
    const { createRequest, error: errorMsg, loading } = useCreateJiraRequest();
    const [open, setOpen] = useState(false);

    const bugReportModalRef = useRef<JiraBugReportModalHandle | null>(null);

    return (
        <div>
            <JiraBugReportModal
                open={open}
                onCancel={() => setOpen(false)}
                onSubmit={async (values: JiraBugReportFormValues) => {
                    const payload = prepareJiraRequestPayload(
                        values.summary,
                        values.description,
                        values.attachments,
                        values.priority,
                    );

                    const response = await createRequest(payload);
                    if (response?.status === 'success') {
                        sendNotification(
                            'success',
                            'Jira Request Created Successfully , Please check your email for the attachments',
                        );
                        setOpen(false);
                        bugReportModalRef.current?.reset();
                    } else {
                        console.log('error: ', errorMsg);
                        sendNotification('error', 'Jira Request Creation Failed, Please try again');
                    }
                }}
                ref={bugReportModalRef}
                loading={loading}
            />

            <Tooltip
                title="Report a Bug"
                color="white"
                overlayInnerStyle={{
                    color: colorConstants.darkGrey,
                }}
            >
                <button
                    type="button"
                    aria-label="Report a Bug"
                    onClick={() => setOpen(true)}
                    className="flex shrink-0 cursor-pointer items-center justify-center rounded-full border border-[#44338a] bg-white p-0 text-[#44338a]"
                    style={{
                        width: size,
                        height: size,
                        minWidth: size,
                        minHeight: size,
                    }}
                >
                    <BugOutlined style={{ fontSize: Math.max(8, Math.round(size * 0.625)) }} />
                </button>
            </Tooltip>
        </div>
    );
};

export default JiraComponent;
